import React from 'react';

const Cart: React.FC = () => {
  return (
    <div className="container">
      <h1>Sepet</h1>
      <p>Sepetiniz burada görünecek...</p>
    </div>
  );
};

export { Cart };

